export default {
    getTeacherIndicators:       { method: 'get', url: 'teacher_indicators' },
    postTeacherIndicators:      { method: 'post', url: 'teacher_indicators' },
    putTeacherIndicators:       { method: 'put', url: 'teacher_indicators/{id}' },
    deleteTeacherIndicators:    { method: 'delete', url: 'teacher_indicators/{id}' },
    indexVariationStatuses:     { method: 'get', url: 'teacher_indicators/variation_statuses' }
}
